import React from "react";
import { Label } from "../InputField/inputFieldStyle";
import Typography from "../Typography/Typography";
import { BtnStyle } from "./buttonStyle";

const Button = ({
  children,
  small,
  color,
  bgColor,
  size,
  onclick,
  type,
  spaceLeft,
  className,
  style,
  disabled,
  border,
  hover,
}) => {
  return (
    <>
      <BtnStyle
        bgColor={bgColor}
        border={border}
        spaceTop=".5rem"
        small={small}
        color={color}
        size={size}
        onClick={onclick}
        type={type}
        spaceLeft={spaceLeft}
        className={className}
        style={style}
        disabled={disabled}
        hover={hover}
      >
        {children}
      </BtnStyle>
    </>
  );
};

export default Button;
